/* HMX V23 — review placement and automatic card savings. */
(() => {
  'use strict';

  if (window.__HMX_V23_REVIEW_CARD_CONGRUENCE__) return;
  window.__HMX_V23_REVIEW_CARD_CONGRUENCE__ = true;

  const formatSavings = (cents) => {
    const value = Math.max(0, Number(cents || 0));
    const currency = window.Shopify?.currency?.active || 'USD';
    const wholeAmount = value % 100 === 0;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: wholeAmount ? 0 : 2,
        maximumFractionDigits: wholeAmount ? 0 : 2
      }).format(value / 100);
    } catch (_) {
      return `$${(value / 100).toFixed(wholeAmount ? 0 : 2)}`;
    }
  };

  const parseMoney = (value) => {
    let text = String(value || '').replace(/\s+/g, '').replace(/[^0-9,.-]/g, '');
    if (!text) return 0;
    const negative = text.includes('-');
    text = text.replace(/-/g, '');
    const dot = text.lastIndexOf('.');
    const comma = text.lastIndexOf(',');
    let decimal = '';
    if (dot >= 0 && comma >= 0) decimal = dot > comma ? '.' : ',';
    else if (dot >= 0 && text.length - dot - 1 === 2) decimal = '.';
    else if (comma >= 0 && text.length - comma - 1 === 2) decimal = ',';

    let amount;
    if (decimal) {
      const index = text.lastIndexOf(decimal);
      const whole = text.slice(0, index).replace(/[.,]/g, '') || '0';
      const fraction = text.slice(index + 1).replace(/[.,]/g, '').padEnd(2, '0').slice(0, 2);
      amount = Number(`${whole}.${fraction}`);
    } else {
      amount = Number(text.replace(/[.,]/g, ''));
    }
    if (!Number.isFinite(amount)) return 0;
    return Math.round(amount * 100) * (negative ? -1 : 1);
  };

  const positionReview = (root) => {
    if (!root) return false;
    const form = root.querySelector('form[data-hmx-product-form]');
    if (!form) return false;

    const slider = root.querySelector('[data-hmx-v12-mini]');
    const fallback = root.querySelector('.hmx-v2__under-review:not([hidden])');
    const review = slider || fallback;
    if (!review) return false;

    review.setAttribute('data-hmx-v23-direct-review', 'true');
    if (form.nextElementSibling !== review) form.insertAdjacentElement('afterend', review);
    return true;
  };

  const initProductRoot = (root) => {
    if (!root || root.dataset.hmxV23ReviewBound === 'true') return;
    root.dataset.hmxV23ReviewBound = 'true';

    [0, 80, 180, 360, 700, 1200, 2200].forEach((delay) => {
      window.setTimeout(() => positionReview(root), delay);
    });

    let timer = 0;
    const observer = new MutationObserver(() => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => positionReview(root), 35);
    });
    observer.observe(root, { childList: true, subtree: true });
  };

  const updateHmxCardSavings = (card) => {
    if (!card) return;
    const badge = card.querySelector('.hmx-v21-card__sale');
    const current = card.querySelector('.hmx-v21-price strong');
    const compare = card.querySelector('.hmx-v21-price s');

    if (badge && current && compare) {
      const currentCents = parseMoney(current.textContent);
      const compareCents = parseMoney(compare.textContent);
      const savings = Math.max(0, compareCents - currentCents);
      if (savings > 0) {
        const formatted = formatSavings(savings);
        badge.textContent = `SAVE ${formatted}`;
        badge.hidden = false;
        badge.setAttribute('aria-label', `Save ${formatted}`);
      } else {
        badge.hidden = true;
        badge.removeAttribute('aria-label');
      }
    }
    card.dataset.hmxV23CardSavingsReady = 'true';
  };

  const updateNativeCardSavings = (card) => {
    if (!card) return;
    const percentageBadges = [...card.querySelectorAll('.card__badge .badge')].filter((badge) =>
      /^\s*\d+(?:\.\d+)?\s*%\s*$/.test(badge.textContent || '')
    );
    if (!percentageBadges.length) return;

    const priceHost = card.querySelector('.card-information');
    const current = priceHost?.querySelector('.price__sale .price-item--sale, .price--on-sale .price-item--sale');
    const compare = priceHost?.querySelector('.price__sale s.price-item--regular, .price--on-sale s.price-item--regular, .price__sale .price-item--regular');
    if (!current || !compare) return;

    const savings = Math.max(0, parseMoney(compare.textContent) - parseMoney(current.textContent));
    if (savings <= 0) return;
    const label = `SAVE ${formatSavings(savings)}`;
    percentageBadges.forEach((badge) => { badge.textContent = label; });
  };

  const enhanceCards = (scope = document) => {
    if (scope?.matches?.('.hmx-v21-card')) updateHmxCardSavings(scope);
    scope?.querySelectorAll?.('.hmx-v21-card').forEach(updateHmxCardSavings);

    if (scope?.matches?.('.product-card-wrapper')) updateNativeCardSavings(scope);
    scope?.querySelectorAll?.('.product-card-wrapper').forEach(updateNativeCardSavings);
  };

  const boot = (scope = document) => {
    if (scope?.matches?.('[data-hmx-wallet-v2]')) initProductRoot(scope);
    scope?.querySelectorAll?.('[data-hmx-wallet-v2]').forEach(initProductRoot);
    enhanceCards(scope);
  };

  const run = () => [0, 100, 300, 700, 1400].forEach((delay) => {
    window.setTimeout(() => boot(document), delay);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
    window.setTimeout(() => boot(event.target), 250);
  });
})();
